import React, { Component } from 'react';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';

import SportSolutionApiWrapper from '../utils/SportSolutionApiWrapper';

class ParticipantsButton extends Component {
  constructor(){
    super();
    this.getParticipants = this.getParticipants.bind(this);
    this.instructors = this.instructors.bind(this);
    this.state = {
      participants: ['loading...'],
      i18nKeeper: document.querySelector('#i18n').dataset

    }
  }
  getParticipants(e){
    let ssaw = new SportSolutionApiWrapper(this.props.user.username, this.props.user.password);
    let that = this;
    let event = this.props.event;
    ssaw.participants(event.id, function(resp){
      that.setState({participants: resp.ss_event.ss_participations.map(p => p)});
    });
  }
  instructors(){
    if(this.props.event.instructor){
      return `${this.state.i18nKeeper.trainer} ${this.props.event.instructor}`
    }else{
      return this.state.i18nKeeper.trainerPlaceholder;
    }
  }
  render(){
    const popoverLeft = (
          <Popover id="popover-positioned-left" title={this.instructors()} positionLeft={0} positionTop={0} arrowOffsetLeft="10%">
            {this.state.participants.map((item, key) => {
              return <span key={key} className={item.on_waiting_list ? "text-danger" : "nope"}>{item.first_name}<br/></span>
            })}
          </Popover>
        );
    return (
      <OverlayTrigger trigger="click" placement="bottom" rootClose container={this} overlay={popoverLeft} onClick={(e) => this.getParticipants(e)}>
        <Button className="button-relative">{this.state.i18nKeeper.participants}</Button>
      </OverlayTrigger>
    )
  }
}

export default ParticipantsButton;
